import { render, staticRenderFns } from "./userRow.vue?vue&type=template&id=466d0f00&scoped=true&"
import script from "./userRow.vue?vue&type=script&lang=js&"
export * from "./userRow.vue?vue&type=script&lang=js&"
import style0 from "./userRow.vue?vue&type=style&index=0&lang=css&"
import style1 from "./userRow.vue?vue&type=style&index=1&id=466d0f00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d0f00",
  null
  
)

/* custom blocks */
import block0 from "./userRow.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VIcon,VRow,VTooltip})
